import { observer } from "mobx-react-lite";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { TrackedEvent, TrackedEventContext, trackEvent } from "@/domains/metrics";
import {
  EmptyContainer,
  EmptyText,
  EmptyTextContainer,
  EmptyTextSubtitle,
} from "@/components/styling/empty";
import EmptySearchImage from "@/assets/images/empty-search.svg?react";
import EmptyNotesImage from "@/assets/images/empty-notes.svg?react";
import EmptySharingImage from "@/assets/images/empty-sharing-notes.svg?react";
import { useTabPageStore } from "@/hooks/useTabPageStore";
import { LensKind } from "@/modules/lenses/types";
import { MDSButton } from "@/mds";

export const NotesListPageListEmpty = observer(function NotesListPageListEmpty() {
  const page = useTabPageStore("notesListPage");

  useEffectOnMount(() => {
    trackEvent(TrackedEvent.ImportCtaView, {
      context: TrackedEventContext.Notes,
    });
  });

  if (page.filters.hasAnyFilters) {
    return (
      <EmptyContainer>
        <EmptySearchImage />
        <EmptyText>No results match your selected filters</EmptyText>
        <MDSButton onClick={() => page.filters.clearAllFilters()}>Clear filters</MDSButton>
      </EmptyContainer>
    );
  }

  if (page.filters.params.lens === LensKind.SharedWithMe) {
    return (
      <EmptyContainer>
        <EmptySharingImage />
        <EmptyText>Notes shared with you appear here</EmptyText>
      </EmptyContainer>
    );
  }

  return (
    <EmptyContainer dataTestId="import-dropzone-ui">
      <EmptyNotesImage />
      <EmptyTextContainer>
        <EmptyText>No notes yet. Drag and drop notes here to import some.</EmptyText>
        <EmptyTextSubtitle>Supported file types: Text (.txt), Markdown (.md)</EmptyTextSubtitle>
      </EmptyTextContainer>
    </EmptyContainer>
  );
});
